module.exports = __webpack_public_path__ + "static/media/save_share_mobile.b1b599a5.mp4";